import React from 'react';
import { Close } from 'styled-icons/material/Close';

import { Text } from '../Text';
import { StyledButton } from '../StyledButton';
import { StyledInnerSelectedItem } from './Combobox.styled';

export const InnerSelectedItem = React.forwardRef(({ children, onRemove }, ref) => (
  <StyledInnerSelectedItem ref={ref}>
    <Text as="span" mr={10} textStyle="ellipsis">
      {children}
    </Text>
    <StyledButton
      onClick={event => {
        event.stopPropagation();
        onRemove();
      }}
      minWidth="14px"
      colors="icon"
    >
      <Close size={14} title="remove" />
    </StyledButton>
  </StyledInnerSelectedItem>
));
